import React, { useState } from 'react'
import { Row } from 'react-bootstrap'
import Imgix from 'react-imgix'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation, Pagination } from 'swiper/core'
import 'swiper/swiper.scss'
import 'swiper/components/navigation/navigation.scss'
import 'swiper/components/scrollbar/scrollbar.scss'
import '../../styles/customSwiper.scss'

import { useResolutionService } from '../../hooks'
import FacultyModal from '../assessmentResult/FacultyModal'

SwiperCore.use([Navigation, Pagination])

const QuestsFaculty = ({ questId, faculties = [] }) => {
  const { isMDScreen } = useResolutionService()
  const [facultyModalMember, setFacultyModalMember] = useState(null)

  const getDescription = (description) => {
    if (!description) return ''
    return description.length > 200
      ? `${description.slice(0, 200)}...`
      : description
  }

  if (!faculties.length) {
    return null
  }

  // Only show faculties where isVisible is true
  const visibleFaculties = faculties.filter((faculty) => faculty.isVisible)
  if (!visibleFaculties.length) {
    return null
  }

  return (
    <>
      <FacultyModal
        show={!!facultyModalMember}
        faculty={facultyModalMember}
        onHide={() => setFacultyModalMember(null)}
      />
      <div>
        <div className='mt-15px'>
          <div className='s3'>Get to Know Your Faculty</div>
          <Row className='align-items-center mb-md-35px position-relative'>
            <Swiper
              slidesPerView={3}
              navigation
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                425: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1024: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1440: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                },
                2560: {
                  slidesPerView: 3,
                  spaceBetween: 80,
                },
              }}
              className='custom-swiper'
              style={{ position: 'unset' }}>
              {visibleFaculties.map((item) => {
                const imageUrl = `${process.env.REACT_APP_IMG_SOURCE}/quest/${item.imageFileName}`
                return (
                  <SwiperSlide key={item.id}>
                    {' '}
                    <div
                      role='button'
                      tabIndex={0}
                      style={{ width: '100%', cursor: 'pointer' }}
                      onClick={() => {
                        setFacultyModalMember({
                          name: item.name,
                          title: item.title,
                          description: item.description,
                        })
                      }}
                      onKeyDown={(e) => {
                        if (e.key !== 'Enter' && e.key !== ' ') return
                        e.preventDefault()
                        setFacultyModalMember({
                          name: item.name,
                          title: item.title,
                          description: item.description,
                        })
                      }}>
                      <Imgix
                        className='border-radius-10 mt-4 lazyload imgix-object-cover'
                        imgixParams={{
                          fit: 'crop',
                          crop: 'faces',
                          ar: isMDScreen ? '2:1' : '5:3',
                        }}
                        src={imageUrl}
                        width={'100%'}
                        alt={`${item.name}'s image`}
                        attributeConfig={{
                          src: 'data-src',
                          srcSet: 'data-srcset',
                          sizes: 'data-sizes',
                        }}
                        htmlAttributes={{
                          src: `${imageUrl}?ar=${
                            isMDScreen ? '2:1' : '5:3'
                          }&fit=crop&crop=faces&fill=blur&blur=300&px=16&auto=format`, // low quality image here
                        }}
                      />
                      <h4 className='s9a pt-16px font-saffron-700'>
                        {item.expertise}
                      </h4>
                      <h2 className='s2'>{item.name}</h2>
                      <p className='s6 pt-16px'>
                        {getDescription(item.description)}
                      </p>{' '}
                    </div>
                  </SwiperSlide>
                )
              })}
            </Swiper>
          </Row>
        </div>
      </div>
    </>
  )
}

export default QuestsFaculty
